<template>
    <span>
        <a :class="{disabled: !hasPrev}" @click="onSelect(current - 1, hasPrev)">
            {{ lang('prev_page', 'table') }}
        </a>
        <a :class="{disabled: !hasNext}" @click="onSelect(current - 1, hasNext)">
            {{ lang('next_page', 'table') }}
        </a>
    </span>
</template>

<script>
    export default {
        props: {
            hasPrev: {
                type: Boolean,
                default: false
            },
            hasNext: {
                type: Boolean,
                default: false
            },
            current: {
                type: Number,
                required: true
            }
        },
        methods: {
            onSelect(page, allowEmit) {
                if (allowEmit) {
                    this.$emit('select', page)
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    a {
        font-size: 14px;
        cursor: pointer;
        color: #000;

        &:hover {
            color: #000;
        }

        &.disabled {
            color: #8a949e;
            cursor: not-allowed;
        }

        &:first-child {
            padding-right: 5px;
        }

        &:last-child {
            padding-left: 5px;
        }
    }
</style>
